/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Partnerships_TitleInputs */

const en_directory_resources_partnerships_title = /** @type {(inputs: Directory_Resources_Partnerships_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a discovery partnership`)
};

const zh_directory_resources_partnerships_title = /** @type {(inputs: Directory_Resources_Partnerships_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共建产品发现合作`)
};

/**
* | output |
* | --- |
* | "Build a discovery partnership" |
*
* @param {Directory_Resources_Partnerships_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_partnerships_title = /** @type {((inputs?: Directory_Resources_Partnerships_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Partnerships_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_partnerships_title(inputs)
	return zh_directory_resources_partnerships_title(inputs)
});
export { directory_resources_partnerships_title as "directory.resources.partnerships.title" }